import { type FC, memo } from 'react';

export type CloudInternetGatewayDetailData = {
  gatewayId: string | null;
  vpcId: string | null;
  name: string | null;
  arn: string | null;
  type: string | null;
};

interface Props {
  firstColumnClassName?: string;
  secondColumnClassName?: string;
  tableClassName?: string;
  tableData: CloudInternetGatewayDetailData;
}

const BareCloudInternetGatewayDetailContent: FC<Props> = (props) => (
  <table className={props.tableClassName}>
    <tbody>
      <tr>
        <td className={props.firstColumnClassName}>Name</td>
        <td className={props.secondColumnClassName}>{props.tableData.name}</td>
      </tr>
      <tr>
        <td className={props.firstColumnClassName}>Internet gateway ID</td>
        <td className={props.secondColumnClassName}>
          {props.tableData.gatewayId}
        </td>
      </tr>
      <tr>
        <td className={props.firstColumnClassName}>Cloud network ID</td>
        <td className={props.secondColumnClassName}>{props.tableData.vpcId}</td>
      </tr>
      <tr>
        <td className={props.firstColumnClassName}>Type</td>
        <td className={props.secondColumnClassName}>{props.tableData.type}</td>
      </tr>
      <tr>
        <td className={props.firstColumnClassName}>ARN</td>
        <td className={props.secondColumnClassName}>{props.tableData.arn}</td>
      </tr>
    </tbody>
  </table>
);

export const CloudInternetGatewayDetailContent = memo(
  BareCloudInternetGatewayDetailContent,
);
